'use client';

import type { Locale } from '@/lib/i18n';

import React, { useState } from 'react';

import { useLingui } from '@lingui/react';
import { usePathname, useRouter } from 'next/navigation';

import { locales, defaultFallbackLocale } from '@/lib/i18n';

function LanguageSelector() {
  const router = useRouter();
  const { i18n } = useLingui();
  const pathname = usePathname();

  const pathLocale = pathname.split('/')[1] ?? '';
  const currentLocale = !Object.keys(locales).includes(pathLocale)
    ? defaultFallbackLocale
    : pathLocale;

  const [locale, setLocale] = useState<Locale>(currentLocale as Locale);

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const localeValue = event.target.value as Locale;

    const pathnameIndex = !Object.keys(locales).includes(
      pathname.split('/')[1] ?? ''
    )
      ? 1
      : 2;

    const pathNameWithoutLocale = pathname.split('/').slice(pathnameIndex);
    const newPath = `/${localeValue}/${pathNameWithoutLocale.join('/')}`;

    setLocale(localeValue);

    router.push(newPath);
  }

  return (
    <label className={'relative'}>
      <select
        value={locale}
        onChange={handleChange}
        className={
          'appearance-none bg-transparent py-1 pl-2 pr-6 cursor-pointer'
        }
      >
        {Object.keys(locales).map((language) => (
          <option value={language} key={language}>
            {i18n._(locales[language as Locale])}
          </option>
        ))}
      </select>
      <span className={'pointer-events-none absolute right-2 top-[1px]'}>
        {'⌄'}
      </span>
    </label>
  );
}

export { LanguageSelector };
